import React, { useEffect, useRef, useState } from 'react'
import { PRINTABLE_WORKSHEET_SCREENS, usePrintableWorksheetsState } from 'printableWorksheets/state'
import { WorksheetCard } from '../worksheetsView/worksheetCard/worksheetCard';
import { getAllWorksheets, getSearchResults } from 'printableWorksheets/api';
import EmptySearchIcon from './empty-search-icon.svg'
import CircleAnimation from 'apps/atoms/CircleAnimation';
import './styles.scss'
import useIsInViewport from 'hooks/useIsInViewport';
import PrintableWorksheetsEvents from 'printableWorksheets/events';
import BackIcon from './back-icon.svg'
import { WorksheetsEnvironment } from 'printableWorksheets';

interface ISearchScreen {
  hideHeader?: boolean;
}

const SearchScreen = ({ hideHeader = false }: ISearchScreen) => {

  const [allWorksheetsOfNode, setAllWorksheetsOfNode] = useState<any>({ title: '', worksheets: [] });
  const { searchScreenData, activeGrade, filteredSearchTerm, worksheetsEnvironment, setFilteredSearchTerm, setActiveScreen, setSearchScreenData } = usePrintableWorksheetsState();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const goBack = () => {
    setActiveScreen(PRINTABLE_WORKSHEET_SCREENS.DEFAULT)
  }

  const fetchSearchData = async () => {
    setIsLoading(true);
    if (searchScreenData?.from === 'RAILS') {
      const res = await getAllWorksheets({ nodeId: searchScreenData.nodeId });
      if (res?.search_contents?.[searchScreenData.nodeId]?.length > 0) {
        setAllWorksheetsOfNode({ title: searchScreenData?.title, worksheets: res?.search_contents[searchScreenData.nodeId] });
      }
    } else {
      await getSearchResults({
        params: searchScreenData.params,
        callback: (res: any) => {
          if (res?.searches?.length > 0) {
            setAllWorksheetsOfNode({ title: searchScreenData?.title, worksheets: res?.searches });
          }
        },
        errorCallback: (err: any) => {
          // sendErrorToSentry(new Error("failed to getSearchResults on search worksheet screen"), { error: err })
        }
      });
    }
    setIsLoading(false)
  };

  const worksheetOnClickHandler = (index: any) => {
    PrintableWorksheetsEvents.interactedWorksheetSearchResultsPage({
      clickedOn: `Search Result ${index + 1}`,
      maxWorksheetViewed: ''
    })
  }

  useEffect(() => {
    if (filteredSearchTerm !== '') {
      const props = {
        searchTerm: filteredSearchTerm,
        countOfSearchResults: allWorksheetsOfNode?.worksheets?.length,
        grade: activeGrade,
      };
      PrintableWorksheetsEvents.startedPrintablesSearch(props);
      setFilteredSearchTerm('');
    }
  }, [filteredSearchTerm]);

  useEffect(() => {
    if (searchScreenData?.from) {
      fetchSearchData();
    }
  }, [searchScreenData]);

  useEffect(() => {
    return () => {
      setAllWorksheetsOfNode({ title: '', worksheets: [] });
      setSearchScreenData(null);
    }
  }, [])

  return (
    <div className={`all-worksheets`}>
      {!hideHeader ? (
        <div className="all-worksheets__header">
          <div className={`go-back${worksheetsEnvironment === WorksheetsEnvironment.STUDENT_DASHBOARD ? ' white-icon' : ''}`} onClick={() => goBack()}>
            <BackIcon />
          </div>
          <div className="title"><span className='ws-title-prefix'>{searchScreenData?.from == 'RAILS' ? `Worksheets/ ` : 'Search results for '}</span>{searchScreenData?.title}</div>
        </div>
      ) : null}
      {isLoading ? (
        <div className="all-worksheets__loading-container">
          <CircleAnimation />
        </div>
      ) : (
        <div className={`all-worksheets__list${hideHeader ? ` strict-view` : ``}`}>
          {allWorksheetsOfNode?.worksheets?.length > 0 ? allWorksheetsOfNode.worksheets.map((worksheet: any, index: any) => {
            const isFromSearchPage = searchScreenData?.from != 'RAILS';
            const isLastCard = isFromSearchPage && index == allWorksheetsOfNode?.worksheets?.length - 1;
            return (
              <div
                key={worksheet.id}
                onClick={() => isFromSearchPage && worksheetOnClickHandler(index)}
              >
                <WorksheetCard
                  card={worksheet}
                  isLastCard={isLastCard}
                />
              </div>
            )
          }) : (
            <div className={`empty-container${worksheetsEnvironment === WorksheetsEnvironment.STUDENT_DASHBOARD ? ' white-theme' : ''}`}>
              <div className="empty-search-worksheets-body">
                <EmptySearchIcon />
                <div className="main-text">{`No result found in Grade ${activeGrade}`}</div>
                <p className="align-centre">{`Sorry! we couldn’t find what you are looking for,
                Please try again`}
                </p>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default SearchScreen